"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readHierarchyOccurrenceFrame = readHierarchyOccurrenceFrame;
const OrcadDsnCfbStreamUtils_1 = require("./OrcadDsnCfbStreamUtils");
function readHierarchyOccurrenceFrame(bytes, record, records, closedBranch = false) {
    const kindOffset = record.offset + 8;
    if (record.payloadByteLength < 20 || bytes[kindOffset] !== 0x42) {
        return undefined;
    }
    const bodyOffset = kindOffset + 11;
    const bodyEnd = bodyOffset + OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt32LE(bytes, kindOffset + 1);
    const closedPayload = (payload) => payload.byteLength !== payload.payloadByteLength ||
        (closedBranch && bodyEnd === bytes.length && payload.offset + payload.payloadByteLength === bodyEnd);
    let container = record;
    let cursor = bodyOffset + 1;
    const length = OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt16LE(bytes, cursor);
    const nameEnd = cursor + 2 + length;
    if (nameEnd + 7 > container.offset + container.payloadByteLength || bytes[nameEnd] !== 0 || bodyEnd > bytes.length) {
        return undefined;
    }
    const name = OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.bytesToAscii(bytes, cursor + 2, nameEnd);
    cursor = nameEnd + 1;
    const selectorIndex = OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt32LE(bytes, cursor);
    cursor += 4;
    const count = OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt16LE(bytes, cursor);
    cursor += 2;
    for (let index = 0; index < count; index++) {
        const end = container.offset + container.payloadByteLength;
        if (!closedPayload(container) || cursor + 12 > end || bytes[cursor] !== 0x44 || bytes[cursor + 9] !== 0x44) {
            return undefined;
        }
        const propertyCount = OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt16LE(bytes, cursor + 10);
        const propertyLength = OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt32LE(bytes, cursor + 1);
        if (propertyLength !== 11 + propertyCount * 8 || cursor + propertyLength + 1 !== end) {
            return undefined;
        }
        const next = records.get(container.offset + container.byteLength);
        if (!next || next.payloadByteLength < 6 || !closedPayload(next)) {
            return undefined;
        }
        container = next;
        cursor = container.offset + 6;
    }
    if (cursor + 10 !== bodyEnd ||
        bodyEnd > container.offset + container.payloadByteLength ||
        !closedPayload(container)) {
        return undefined;
    }
    if (bytes.subarray(cursor, bodyEnd).some((byte) => byte !== 0)) {
        return undefined;
    }
    return { name, nameOffset: bodyOffset + 1, selectorIndex };
}
//# sourceMappingURL=OrcadDsnCfbOccurrenceFrames.js.map